/**Packages */
import React from 'react';
/**Helpers */
import { manageAssistant } from '../../../helpers/assistant';
/* Components */
import { Header } from '../../shared/Header';
import { MainContentWrapper } from '../../shared/MainContentWrapper';
import { Button } from '../../shared/Button';
import { Footer } from '../../shared/Footer';

/* CSS */
import './style.css';

export const Offline = () => {
  
  manageAssistant();
  const returnUrl = `/simulatore${localStorage.getItem('homePage') ? localStorage.getItem('homePage') : '/simulatore-commerciale.html'}`;
  
  return (
    <>
      <Header
        logo={
          {
            image: './images/logo_compass_negative.png',
            alt: 'Logo compass negative',
            redirect: returnUrl,
          }
        }
      />
      <MainContentWrapper mainClass="offline">
        <div className="offline__main-content-wrapper row justify-content-center">
          <div className="col-12 col-lg-3 d-flex">
            <img className="mx-auto" src="./images/sorry_icon.svg" />
          </div>
          <div className="w-100 d-lg-none"></div>
          <div className="offline__text-wrapper col-12 col-md-10 col-lg-5">
            <p className="offline__text offline__text--big">Siamo spiacenti, ma purtroppo non è possibile procedere online con la tua richiesta.</p>
            <p className="offline__text offline__text--big">Se vieni in filiale avrai più possibilità di ottenere il prestito e nel migliore dei casi potrai averlo <strong>in un giorno</strong>.</p>
            <div className="offline__button-row row d-none d-lg-block">
              <div className="col-lg-9">
                <Button color="white" type="button" rounded={true} text="Fissa appuntamento" clickEvent={function() { window.location.href = "/fissa-appuntamento?utm_source=DS&utm_campaign=downDs&mediacode=4492"; }} />
              </div>
            </div>
          </div>
          <div className="w-100 d-lg-none"></div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-4 d-lg-none">
            <Button color="white" type="button" rounded={true} text="Fissa appuntamento" clickEvent={function() { window.location.href = "/fissa-appuntamento?utm_source=DS&utm_campaign=downDs&mediacode=4492"; }} />
          </div>
        </div>
        <div className="offline__more-info-wrapper row justify-content-center">
          <div className="col-12 col-sm-6 col-md-6 col-lg-4">
            <p className="offline__text offline__text--centered">Hai bisogno di maggiori informazioni?</p>
            <Button color="white" hollow={true} type="button" rounded={true} text="Chiamaci: 800 774433" clickEvent={function() { window.location.href = "tel:800 774433"; }} />
          </div>
        </div>
      </MainContentWrapper>
      <Footer showDynamicParagraph={false}/>
    </>
  );
}

export default Offline;
